import {Component, Input, OnInit} from '@angular/core';
import {GetSetDataService} from '../../services/get-set-data.service';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {NgForOf, NgIf} from '@angular/common';

@Component({
  selector: 'app-main-navigation',
  templateUrl: './main-navigation.component.html',
  imports: [
    RouterLinkActive,
    RouterLink,
    NgForOf,
    NgIf
  ],
  styleUrls: ['./main-navigation.component.scss']
})
export class MainNavigationComponent implements OnInit {

  @Input() navigationItems: any;

  public allReportsCounter: any;
  public showAllCategories = false;
  public readonly VISIBLE_COUNT = 9;

  constructor(private getSetData: GetSetDataService) {}

  async ngOnInit() {
    this.allReportsCounter = await this.getSetData.getPostsCount();
  }

  get visibleItems(): any[] {
    if (!this.navigationItems) return [];
    return this.showAllCategories ? this.navigationItems : this.navigationItems.slice(0, this.VISIBLE_COUNT);
  }

  get hiddenCount(): number {
    if (!this.navigationItems) return 0;
    return Math.max(0, this.navigationItems.length - this.VISIBLE_COUNT);
  }

  public toggleShowAll() {
    this.showAllCategories = !this.showAllCategories;
  }

  public hideMainNavigation() {
    if (window.innerWidth <= 1100) {
      document.getElementsByTagName('body')[0].classList.remove('menu-hidden');
    }
  }
}
